import { PersonOff } from "@mui/icons-material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";

/**
 * Вход в IMS прошёл, но записи пользователя в EkoCrop нет. Сюда ведёт бэкенд EkoCrop.
 * Кнопки «Войти под другой учётной записью» нет, пока BFF не умеет завершать
 * сессию IMS без локальной сессии EkoCrop.
 */
export const AccountNotConnectedPage = (): JSX.Element => (
  <InfoPageLayout>
    <InfoPage
      title="Учётная запись не подключена"
      message="Обратитесь к администратору, чтобы подключить её к EkoCrop"
      illustration={<InfoPageIllustration icon={PersonOff} />}
      actions={<SignInButton />}
    />
  </InfoPageLayout>
);
